<div class="body">
  <div class="container">
    <div class="row title-box">
      <div class="col-12 col-sm-12 mt-2">
        <h3 class="txtbienvenida">
          Parametrización
          <span class="txtbienvenida-2">lugares de atención</span>
        </h3>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-sm-12 mt-3">
        <p class="title-box">*Desde aquí puedes cargar un archivo para que se creen los lugares de atención. Por favor,
          ten en cuenta las siguientes guías según el formato que desees cargar:
          <a class="fas IcoForm fa-file text-white ms-2" style="cursor: pointer;"
                      title="Descargar guía txt" (click)="_modal.descargaModal('assets/files/Carga de lugares de atención.txt',
                      'Carga de lugares de atención','.txt')"></a>
          <a class="fas IcoForm fa-file-excel text-success ms-2 me-1" style="cursor: pointer;"
                      title="Descargar guía xls" (click)="_modal.descargaModal('assets/files/Carga de lugares de atención.xls',
                      'Carga de lugares de atención','.xls')"></a> y sigue las instrucciones proporcionadas.</p>
        </div>
      </div>
      <div class="row justify-content-center g-2">
        <div class="col-12 col-md-4 container-btn">
          <button class="btn btn-primary hvr-shrink" (click)="fileInput.click()">
            <span class="fas fa-upload fa-u"></span> Cargar lugares de atención
          </button>
          <input #fileInput type="file" (change)="capturarFile($event)" hidden accept=".xls,.txt" (click)="(fileInput.value = null)" />

        </div>
        <div class="col-12 col-md-3 container-btn">
          <button type="button" id="btn-agregar" [routerLink]="['crear']" style="width: 220px;" class="btn btn-primary hvr-shrink">
            Crear lugar de atención
          </button>
        </div>
        <div class="col-12 col-md-3 container-btn">
          <button class="btn btn-primary hvr-shrink" style="width: 220px;" routerLink="/intermediario/home">
            Volver
          </button>
        </div>
      </div>
      <hr style="border-width: 2px; border-style: solid; border-color: white;">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xs-4 mt-4">
          <div [formGroup]="filtrosForm">
            <div class="mb-3 form-label">
              <label for="departamento" class="form-label">Departamento atención</label>
              <select #dept class="form-control selectpicker" data-size="3" data-live-search="true" formControlName="departamento" (change)="getCiudades(dept.value)" title="Seleccione una opción" required>
                @for (dp of departamentos; track dp) {
                  <option [value]="dp.idDepartamento">
                    {{ dp.nombreDepartamento | uppercase }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xs-4 mt-4">
          <div [formGroup]="filtrosForm">
            <div class="mb-3 form-label">
              <label for="ciudad" class="form-label">Ciudad atención</label>
              <select #ciud id="ciud" class="form-control selectpicker" data-size="5" data-live-search="true" formControlName="ciudad" title="Seleccione una opción" required>
                @for (cd of ciudades; track cd) {
                  <option [value]="cd.idCiudad">
                    {{ cd.nombreCiudad | uppercase }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-2 container-btn mt-2 g-2">
          <button type="button" [disabled]="!comprobarValoresFormularioFiltro()" (click)="filtrarLista()" class="btn btn-primary hvr-shrink" style="width: 220px;">
            Filtrar
          </button>
        </div>
        <div class="col-12 col-md-2 container-btn">
          <button type="button" (click)="resetearFormularioFiltro()" class="btn btn-primary hvr-shrink" style="width: 220px;">
            Limpiar filtro
          </button>
        </div>

      </div>
      <div class="row pr-3 pl-3">
        <div class="table-responsive">
          <table class="table table-striped table-borderless rounded">
            <thead class="table_head">
              <tr>
                <th scope="col" class="no-styles table-header" id="date-rango">
                  Departamento atención
                </th>
                <th scope="col" class="no-styles table-header" id="date-rec">
                  Aplica a todas las ciudades
                </th>
                <th scope="col" class="no-styles table-header" id="solicitante">
                  Estado lugar atención
                </th>
                <th scope="col" class="no-styles table-header" id="doc">
                  Fecha de creación del lugar
                </th>
                <th scope="col" class="no-styles table-header" id="doc">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              @for (ubi of ubicacionesIntermediario; track ubi) {
                <tr>
                  <td>{{ getNombreDepartamento(ubi.idDepartamento) }}</td>
                  <td>
                    {{ ubi.aplicaTodasCiudades == 1 ? "SI" : "NO" }}
                  </td>
                  <td>
                    {{ ubi.estado }}
                  </td>
                  <td>{{ ubi.fechaCreacion | date: "dd/MM/yyyy, h:mm a" }}</td>
                  <td>
                    <button type="button" id="btn-editar" [routerLink]="['editar',ubi.idDepartamentoCliente]">
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                    <button type="button" id="btn-borrar" (click)="eliminarRegistroUbicacion(ubi)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="footer-body"></div>
  </div>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
